import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * TenantTable Component
 * A clean, simple table component for displaying tenant data
 */
const TenantTable = ({ tenants, onView, onEdit, onDelete }) => {
    const navigate = useNavigate();
    return (
        <div className="overflow-x-auto border border-gray-100 rounded-lg shadow-sm">
            <table className="w-full bg-white text-sm">
                <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                    <tr className="border-b border-gray-200">
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Tenant</th>
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Domain</th>
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Status</th>
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Users</th>
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Type</th>
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Created</th>
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Last Activity</th>
                        <th className="text-left px-4 py-2 font-medium text-gray-600 text-xs uppercase">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {tenants.map((tenant) => (
                        <tr key={tenant.id} className="border-b border-gray-100 hover:bg-gray-50">
                            <td className="px-4 py-2">
                                <div className="flex items-center">
                                    <div className={`w-8 h-8 rounded flex items-center justify-center text-white text-xs font-semibold mr-2 ${
                                        tenant.isAdmin ? 'bg-purple-500' : 'bg-blue-500'
                                    }`}>
                                        {tenant.name.charAt(0)}
                                    </div>
                                    <div>
                                        <div className="font-medium text-gray-900">{tenant.name}</div>
                                        <div className="text-xs text-gray-500">ID: {tenant.id}</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-4 py-2 text-gray-700">{tenant.domain}</td>
                            <td className="px-4 py-2">
                                <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded ${
                                    tenant.status === 'active' 
                                        ? 'bg-green-100 text-green-800' 
                                        : 'bg-red-100 text-red-800'
                                }`}>
                                    {tenant.status.charAt(0).toUpperCase() + tenant.status.slice(1)}
                                </span>
                            </td>
                            <td className="px-4 py-2 text-center font-medium">{tenant.userCount}</td>
                            <td className="px-4 py-2">
                                <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded ${
                                    tenant.isAdmin 
                                        ? 'bg-purple-100 text-purple-800' 
                                        : 'bg-blue-100 text-blue-800'
                                }`}>
                                    {tenant.isAdmin ? 'Admin' : 'Vendor'}
                                </span>
                            </td>
                            <td className="px-4 py-2 text-gray-600 text-xs">{tenant.createdAt}</td>
                            <td className="px-4 py-2 text-gray-600 text-xs">{tenant.lastActivity}</td>
                            <td className="px-4 py-2">
                                        <div className="flex items-center gap-2">
                                            <button 
                                                onClick={() => navigate(`/admin/tenant/${tenant.id}`)}
                                                style={{
                                                    all: 'unset',
                                                    padding: '4px 8px',
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    color: '#2563eb',
                                                    backgroundColor: '#eff6ff',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    border: 'none',
                                                    outline: 'none'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#dbeafe'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = '#eff6ff'}
                                            >
                                                View
                                            </button>
                                            <button 
                                                onClick={() => navigate(`/admin/tenant/${tenant.id}`)}
                                                style={{
                                                    all: 'unset',
                                                    padding: '4px 8px',
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    color: '#6b7280',
                                                    backgroundColor: '#f9fafb',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer',
                                                    border: 'none',
                                                    outline: 'none'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = '#f9fafb'}
                                            >
                                                Edit
                                            </button>
                                            {!tenant.isAdmin && onDelete && (
                                                <button 
                                                    onClick={() => onDelete(tenant)}
                                                    style={{
                                                        all: 'unset',
                                                        padding: '4px 8px',
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        color: '#dc2626',
                                                        backgroundColor: '#fef2f2',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        border: 'none',
                                                        outline: 'none'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#fee2e2'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#fef2f2'}
                                                >
                                                    Delete
                                                </button>
                                            )}
                                        </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TenantTable;
